// Plain names for where an app was first installed from, as Firebase reports it. One copy, used by
// Customer 360's app strip and by the bookings-by-install-source card, so the two can never name the same pair
// differently.

/**
 * Plain names for the install-source pairs Firebase actually reports (measured over 7 days of customers:
 * (direct) 8,273, google-play/organic 1,980, google/cpc 640, REFER 154, firebase/dynamic_link 69,
 * google/organic 45). Anything not listed keeps its raw text and `known: false`.
 */
export function arrivedVia(
  source: string | null,
  medium: string | null,
): { label: string; known: boolean } | null {
  const s = (source ?? '').trim();
  const m = (medium ?? '').trim();
  if (!s) return null;
  const sl = s.toLowerCase();
  const ml = m.toLowerCase();
  // "(direct)" is only "no campaign" when the medium says so; "(direct) / cpc" would be a guess, so it stays raw.
  if (sl === '(direct)' && (ml === '' || ml === '(none)' || ml === '(not set)' || ml === '?')) {
    return { label: 'Direct (no campaign)', known: true };
  }
  if (sl === 'google-play' && ml === 'organic') return { label: 'Google Play (organic)', known: true };
  if (sl === 'google' && ml === 'cpc') return { label: 'Google Ads', known: true };
  if (sl === 'google' && ml === 'organic') return { label: 'Google search (organic)', known: true };
  if (sl === 'refer') return { label: 'Referral', known: true };
  if (sl === 'firebase' && ml === 'dynamic_link') return { label: 'Invite link', known: true };
  const raw = m && m !== '(none)' && m !== '?' ? `${s} / ${m}` : s;
  return { label: raw, known: false };
}
